import "./css/App.css";
import * as React from "react";
import Posts from "./components/posts";
import PostMap from "./components/postMap";
import axios from "axios";
const updtSecCoords = 1;

const App = (props) => {
  const tblName = props.table;
  const [ip, setIP] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [allMarkers, setAllMarkers] = React.useState([]);

  var commentLen = 0;
  if (tblName.length > 0) {
    var strURL = 'https://api.chonerman.com/commenter?tblName=' + tblName;
  } else {
    var strURL = 'https://api.chonerman.com/commenter';
  }

  const MyLoader = () => (
    <svg className="loader" version="1.1" id="L5" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 0 0">
      <circle fill="red" stroke="none" cx="6" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 15 ; 0 -15; 0 15"
          repeatCount="indefinite"
          begin="0.1" />
      </circle>
      <circle fill="white" stroke="none" cx="30" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 10 ; 0 -10; 0 10"
          repeatCount="indefinite"
          begin="0.2" />
      </circle>
      <circle fill="blue" stroke="none" cx="54" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3" />
      </circle>
    </svg>
  );

  const getIP = async () => {
    const res = await axios.get("https://api.ipify.org?format=json");
    setIP(res.data.ip);
  }

  const getMarkers = async function () {
    try {
      var response = await axios.get(strURL);
      setLoading(false);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  //get IP and lat/lng
  React.useEffect(() => {
    getIP();
  }, []);

  //get comments/markers
  React.useEffect(() => {
    const fetchMarkers = async () => {
      var mkrs = await getMarkers();
      if (mkrs.length !== commentLen) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        commentLen = mkrs.length;
        setAllMarkers(mkrs);
      } else {
        //console.log("no new comments");
      }
    };

    const interval = setInterval(async () => {
      fetchMarkers();
    }, (updtSecCoords * 1000));
    return () => clearInterval(interval);

  }, []);

  return (
    <>
      {loading /* || ((mylat === '0') && (mylong === '0'))  */ ? (

        <header className="App-header">
          <div className="masterLoader">
            {MyLoader()}
          </div>
        </header>

      ) : (

        <header className="App-header">
          <div className="mapWrapper">
            <PostMap /* lat={mylat} long={mylong}  */ markers={allMarkers} />
          </div>
          <Posts table={tblName} ip={ip} /* mlat={mylat} mlong={mylong} */ comments={allMarkers} />
        </header>

      )}
    </>
  )
}

export default App;
